/* Estimated arrival dates for [data-sa-eta] (business days, Mon–Fri, from today). */
(function () {
  if (window.saEta) return;

  function addBusinessDays(date, days) {
    var d = new Date(date.getTime());
    while (days > 0) {
      d.setDate(d.getDate() + 1);
      var day = d.getDay();
      if (day !== 0 && day !== 6) days--;
    }
    return d;
  }

  function fmt(d) {
    return d.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' });
  }

  window.saEta = function (root) {
    (root || document).querySelectorAll('[data-sa-eta]').forEach(function (el) {
      var min = parseInt(el.dataset.min, 10);
      var max = parseInt(el.dataset.max, 10);
      if (!min || !max) return;
      var now = new Date();
      el.textContent = 'Estimated arrival: ' + fmt(addBusinessDays(now, min)) + ' – ' + fmt(addBusinessDays(now, max));
    });
  };

  function run() { window.saEta(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  // Cart drawer and section re-renders replace the markup.
  new MutationObserver(function (records) {
    for (var i = 0; i < records.length; i++) {
      for (var j = 0; j < records[i].addedNodes.length; j++) {
        var n = records[i].addedNodes[j];
        if (n.nodeType === 1 && (n.matches('[data-sa-eta]') || n.querySelector('[data-sa-eta]'))) { run(); return; }
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
